import React from 'react';
import { Globe, Users } from 'lucide-react';

// Only the exact value "everyone" is wider than your connections. Anything else
// is treated as connections-only, matching the backend's fail-closed rule.
export const isEveryone = (visibility) => visibility === 'everyone';

export const VISIBILITY_OPTIONS = [
  {
    value: 'connections',
    label: 'My connections',
    hint: 'Only your mutual connections can see this.',
    Icon: Users,
  },
  {
    value: 'everyone',
    label: 'Everyone on irecommend',
    hint: 'Any member can see this in Explore. Your name is shown.',
    Icon: Globe,
  },
];

// Small badge shown on a card. Connections-only is the expected default, so it
// is surfaced to the author on their own content rather than on every card.
export const VisibilityBadge = ({ visibility, showConnections = false }) => {
  const everyone = isEveryone(visibility);
  if (!everyone && !showConnections) return null;
  const Icon = everyone ? Globe : Users;
  return (
    <span
      className={`rc-visibility ${everyone ? 'everyone' : 'connections'}`}
      data-testid={`rec-visibility-${everyone ? 'everyone' : 'connections'}`}
    >
      <Icon className="rc-visibility-icon" />
      {everyone ? 'Everyone' : 'My connections'}
    </span>
  );
};
